import { render } from "./MyCompanyName_EN.vue?vue&type=template&id=2cb9b95d"
import script from "./MyCompanyName_EN.vue?vue&type=script&lang=js"
export * from "./MyCompanyName_EN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__